export const ACCOUNT_CONSTANTS = {
    UPLOAD_IMG: ':/api/users/file-upload/upload-profile-picture'
};
